// Shared constants for table components

// List of advanced table column keys to be treated as money fields
export const TABLE_MONEY_COLUMN_KEYS = [
  'cityTaxAmount',
  'cost',
  'countyTaxAmount',
  'discountTotal',
  'discount',
  'total',
  'multiCurrencyDiscountTotal',
  'multiCurrencyItemPrice',
  'multiCurrencySubTotal',
  'multiCurrencyTaxTotal',
  'multiCurrencyTotal',
  'price',
  'specialDistrictTaxAmount',
  'stateTaxAmount',
  'subTotal',
  'tax',
];
